import { USER_WALLET_STATE } from './constants'

export const getIsFetching = state => state[USER_WALLET_STATE]?.isFetching
export const getAvailableCredit = state => state[USER_WALLET_STATE]?.availableCredit
